import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SidebarService } from '../sidebar/sidebar.service';
import { DateRangePickerComponent } from '../../../../core/date-range-picker/date-range-picker.component';
import { DateRangePickerService } from '../../../../core/date-range-picker/date-range-picker.service';
import { Subscription } from 'rxjs';
import { IncompleteDataService } from '../../../../core/services/incomplete-data.service';
import { IncompleteData } from '../../../../core/models/incomplete-data';
import { ModalIncompleteService } from '../../../../core/modal-incomplete/modal-incomplete.service';
import { User } from '../../../../core/models/user';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (this.modalDateRangePicker) {
      const target = event.target as HTMLElement;
      const datePickerContainer = document.querySelector('.date-picker-wrapper');
      const toggleButton = document.querySelector('.btn-success-custom');

      if (datePickerContainer && !datePickerContainer.contains(target) &&
        toggleButton && !toggleButton.contains(target)) {
        this.modalDateRangePicker = false;
      }
    }
  }

  currentDate: Date = new Date();

  // Simulated user data
  user = {
    name: 'John Doe',
    avatar: 'assets/images/avatar.png'
  };

  selectedDateRange: string = 'Select Date Range';
  modalDateRangePicker: boolean = false;
  showIncompleteData: boolean = false;
  // Untuk mengelola subscription
  private subscription = new Subscription();

  isIncomplete: boolean = false;
  ItemData: IncompleteData[] = []
  itemCurrentUser: User = {} as User;
  itemPicture: string = "";

  constructor(
    private sidebarService: SidebarService,
    private dateRangeService: DateRangePickerService,
    private serviceData: IncompleteDataService,
    private modalIncompleteService: ModalIncompleteService
  ) { }

  ngOnInit() {

    const userData = localStorage.getItem('currentUser');
    this.itemCurrentUser = userData ? JSON.parse(userData) : {} as User;
    this.itemPicture = (this.itemCurrentUser.picture && this.itemCurrentUser.picture.trim() !== '')
      ? this.itemCurrentUser.picture
      : 'assets/images/default-user-profile.png';

    // // Subscribe ke perubahan date range
    this.subscription.add(
      this.dateRangeService.dateRange$.subscribe(range => {
        // Update display
        this.loadDataIncomplete();

        this.selectedDateRange = `${this.formatDate(range.start)} - ${this.formatDate(range.end)}`;
      })
    );

    this.initializeDateRanges();

    // Tambahkan event listener untuk storage event
    window.addEventListener('storage', this.handleStorageChange.bind(this));

  }

  ngOnDestroy() {
    // Bersihkan subscription saat komponen dihancurkan
    this.subscription.unsubscribe();

    // Hapus event listener
    window.removeEventListener('storage', this.handleStorageChange.bind(this));
  }

  private formatDate(date: Date): string {
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
  }

  private initializeDateRanges(): void {
    // console.log('AppComponent: Ensuring date ranges are initialized');

    // Cek apakah sudah ada data di localStorage
    const startDate = localStorage.getItem('startDate');
    const endDate = localStorage.getItem('endDate');

    if (!startDate || !endDate) {
      console.log('AppComponent: No date ranges found, creating default');

      // Inisialisasi ulang dari service
      this.dateRangeService.initializeFromLocalStorage();

      // Double-check setelah inisialisasi
      const newStartDate = localStorage.getItem('startDate');
      const newEndDate = localStorage.getItem('endDate');

      console.log('AppComponent: After initialization check:', {
        startDate: newStartDate,
        endDate: newEndDate
      });
    } else {
      // console.log('AppComponent: Date ranges already exist in localStorage');
    }
  }

  // Handler untuk storage event
  private handleStorageChange(event: StorageEvent) {
    if (event.key === 'startDate' || event.key === 'endDate') {
      const startDateStr = localStorage.getItem('startDate');
      const endDateStr = localStorage.getItem('endDate');

      if (startDateStr && endDateStr) {
        const start = new Date(startDateStr);
        const end = new Date(endDateStr);

        this.selectedDateRange = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      }
    }
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  onDateRangeSelected(range: { start: Date; end: Date }) {
    this.selectedDateRange = `${this.formatDate(range.start)} - ${this.formatDate(range.end)}`;
    // this.modalDateRangePicker = false; // Close after selection

    // Log untuk debug
    console.log('Header received dateRangeSelected event:', {
      start: range.start.toLocaleDateString(),
      end: range.end.toLocaleDateString(),
      display: this.selectedDateRange
    });
  }

  toggleDateRangePicker() {
    this.modalDateRangePicker = !this.modalDateRangePicker;
  }

  toggleIncompleteData() {
    this.showIncompleteData = !this.showIncompleteData;
  }

  loadDataIncomplete() {

    const start_date = localStorage.getItem('startDate')
    const end_date = localStorage.getItem('endDate')

    this.serviceData.getIncompleteData(
      start_date ?? undefined,
      end_date ?? undefined
    ).subscribe({
      next: (response) => {
        this.ItemData = this.processIncompleteData(response.data);
        // this.ItemData = response.data
        // console.log(response.data)


        if (this.ItemData.length === 0) {
          this.isIncomplete = false;
        } else {
          this.isIncomplete = true;
        }
      },
      error: (error) => {
        console.error('Error loading incomplete data:', error)
        this.ItemData = []
      }
    })
  }

  processIncompleteData(data: IncompleteData[]): IncompleteData[] {
    return data.map(item => {
      const dates = (item.incomplete_data ?? '').split(', ').filter(date => date.trim());

      if (dates.length <= 2) {
        return {
          ...item,
          displayData: this.formatDates(dates),
          hasMore: false,
          showInfoIcon: dates.length > 0  // Property baru
        };
      } else {
        const limitedDates = dates.slice(0, 2);
        return {
          ...item,
          displayData: this.formatDates(limitedDates),
          hasMore: true,
          showInfoIcon: true  // Property baru
        };
      }
    });
  }


  formatDates(dates: string[]): string {
    return dates.map(date => {
      // Jika format seperti "2025-05-09", ubah ke "09/05/25"
      if (date.includes('-') && date.length === 10) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year.slice(-2)}`;
      }
      // Jika format seperti "2025-W18", biarkan apa adanya atau sesuaikan
      else if (date.includes('W')) {
        return date;
      }
      // Jika hanya tahun "2025"
      else if (date.length === 4) {
        return date;
      }
      return date;
    }).join(', ');
  }

  showFullData(item: IncompleteData) {
    // Tutup dropdown
    this.showIncompleteData = false;

    // Ambil parameter tanggal dari localStorage
    const start_date = localStorage.getItem('startDate');
    const end_date = localStorage.getItem('endDate');

    // Call API dengan businessLineId
    this.serviceData.getIncompleteDataDetail(
      start_date ?? undefined,
      end_date ?? undefined,
      item.id  // ID business line yang diklik
    ).subscribe({
      next: (response) => {
        // Kirim data detail ke modal
        this.modalIncompleteService.showModalWithDetail(
          item.name,
          response.data,  // Array IncompleteDataDetail
          item.id
        );
      },
      error: (error) => {
        // Fallback ke data lama jika API gagal
        this.modalIncompleteService.showModal(item.name, item.incomplete_data, item.id);
      }
    });
  }

}
